<template>
  <v-dialog
    v-model="alert.show"
    max-width="800px"
  >
    <v-card>
      <template #title>
        <v-alert
          v-if="alert.title"
          :value="true"
          type="error"
        >
          {{ alert.title }}
        </v-alert>
      </template>

      <v-card-text v-if="alert.body">
        <pre v-if="alert.pre===true">{{ translateErrorRes(alert.body) }}</pre>
        <div v-else v-html="translateErrorRes(alert.body)" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          flat
          @click.stop="hideAlert"
        >
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import InputMixin from '../../components/parts/inputs/InputMixin'

export default {
  mixins: [InputMixin],
  computed: {
    ...mapGetters(['alert'])
  },
  methods: {
    hideAlert () {
      this.$store.dispatch('hide_alert')
    }
  }
}
</script>
